import { IconButton, HStack } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { InputMoney } from '../../../../../../../components/InputMoney';
import { RiskRating } from '../../../../../../../components/RiskRating';
import {
  TableContentItemCaptions,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../components/TableContent';
import { messageError } from '../../../../../../../store/batchTicket/constants';

import { AddedProductResponsiveItemFundsProps } from '.';

export const AddedProductItemFundsDesktop: React.FC<AddedProductResponsiveItemFundsProps> = ({
  data,
  inputMoneyDataProps,
  minimumMovimentationFormatted,
  onRemoveProduct,
}) => {
  return (
    <HStack
      w={'full'}
      space={Spacing['inline.xxxs']}
      justifyContent="space-between"
      alignItems="center">
      <TableContentItemColumn flex={3} space={Spacing['inline.quarck']}>
        <TableContentItemText>{data.productDisplay}</TableContentItemText>
        <TableContentItemCaptions forceDesktop icons={data.captions || []} />
      </TableContentItemColumn>
      <TableContentItemColumn maxW="105px" space={Spacing['inline.quarck']}>
        <TableContentItemText>Tipo</TableContentItemText>
        <TableContentItemText>{data.productCategory}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn maxW="90px" space={Spacing['inline.quarck']}>
        <TableContentItemText>Rent. 12 meses</TableContentItemText>
        <TableContentItemText>
          {Utils.Mask.Percentage(data.profitabilityTwelveMonthsAdjusted)}
        </TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn maxW="80px" space={Spacing['inline.quarck']}>
        <TableContentItemText>Taxa Admin.</TableContentItemText>
        <TableContentItemText>{data.administrationFee}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn maxW="80px" space={Spacing['inline.quarck']}>
        <TableContentItemText>Resgate</TableContentItemText>
        <TableContentItemText>{data.quotationRedemptionTermFormatted}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn maxW="110px" space={Spacing['inline.nano']}>
        <TableContentItemText>Risco</TableContentItemText>
        <RiskRating
          currentRiskRating={data.riskRatingLevel || 0}
          tooltip={data.riskRating || messageError}
        />
      </TableContentItemColumn>
      <TableContentItemColumn maxW="100px" space={Spacing['inline.quarck']}>
        <TableContentItemText>Aplicação mín.</TableContentItemText>
        <TableContentItemText>{minimumMovimentationFormatted}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn minW="130px" space={Spacing['inline.quarck']}>
        <TableContentItemText>Valor a aplicar</TableContentItemText>
        <InputMoney {...inputMoneyDataProps} />
      </TableContentItemColumn>
      <IconButton
        testId="icon-button"
        onPress={onRemoveProduct}
        borderRadius={BoxRadius.sm}
        icon="Trash"
        p={0}
        iconColor={Color['feedback.error.default']}
        iconSize="xs"
      />
    </HStack>
  );
};
